import { Component, Prop, Vue } from "vue-property-decorator";
import { IUser, Role } from "@/models";
@Component({
    name: "header-app",
})
export default class HeaderApp extends Vue {

    @Prop({ required: true })
    public user: IUser;

    @Prop()
    public version: string;

    public get userName(): string {
        return this.user?.name;
    }

    public get userPhotoBase(): string {
        const imgLink = require("@/assets/img/default-profil-picture.png");
        return this.user?.photoBase64 ?
            "data:image/png;base64, " + this.user.photoBase64 :
            imgLink;
    }

    public get isAdmin(): boolean {
        return this.user?.role === Role.Admin;
    }

    public get isUser(): boolean {
        return this.user?.role === Role.User;
    }

    public logout(): void {
        this.$store.dispatch("app/logout");
    }
}
